import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
  Grid,
  Alert,
} from "@mui/material";

const API = process.env.REACT_APP_API_URL;

export default function VideoReview() {
  const [pendingVideos, setPendingVideos] = useState([]);
  const [alert, setAlert] = useState({ message: "", severity: "" });

  useEffect(() => {
    fetch(`${API}/pendingVideos`)
      .then((res) => res.json())
      .then((data) => setPendingVideos(data))
      .catch((err) => {
        console.error("Fetch error:", err);
        setAlert({ message: "Failed to fetch videos.", severity: "error" });
      });
  }, []);

  useEffect(() => {
    if (alert.message) {
      const timer = setTimeout(() => {
        setAlert({ message: "", severity: "" });
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [alert]);

  const approveVideo = async (id) => {
    try {
      const res = await fetch(`${API}/pendingVideos/approve/${id}`, {
        method: "POST",
      });
      if (res.ok) {
        setAlert({ message: "Video approved!", severity: "success" });
        setPendingVideos(pendingVideos.filter((p) => p._id !== id));
      } else {
        const err = await res.json();
        setAlert({
          message: err.error || "Failed to approve video.",
          severity: "error",
        });
      }
    } catch (err) {
      console.error("Approval error:", err);
      setAlert({ message: "Error approving video.", severity: "error" });
    }
  };

  const rejectVideo = async (id) => {
    try {
      const res = await fetch(`${API}/pendingVideos/${id}`, {
        method: "DELETE",
      });
      if (res.ok) {
        setAlert({
          message: "Video rejected and deleted.",
          severity: "success",
        });
        setPendingVideos(pendingVideos.filter((p) => p._id !== id));
      } else {
        const err = await res.json();
        setAlert({
          message: err.error || "Failed to delete video.",
          severity: "error",
        });
      }
    } catch (err) {
      console.error("Rejection error:", err);
      setAlert({ message: "Error rejecting video.", severity: "error" });
    }
  };

  return (
    <Box py={2}>
      <Typography
        variant="h3"
        fontWeight="bold"
        color="black"
        textAlign="center"
        gutterBottom
      >
        PENDING VIDEOS
      </Typography>

      {alert.message && (
        <Alert severity={alert.severity} sx={{ mb: 3 }}>
          {alert.message}
        </Alert>
      )}

      <Grid container spacing={3}>
        {pendingVideos.map((video) => (
          <Grid item xs={12} md={6} key={video._id}>
            <Card>
              <CardContent>
                <Typography variant="h6">{video.title}</Typography>
                <Typography variant="subtitle2" color="textSecondary">
                  {video.subtitle}
                </Typography>
                <Typography variant="subtitle2" color="textSecondary">
                  <a
                    href={video.videoUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {video.videoUrl}
                  </a>
                </Typography>
                <Box mt={2}>
                  <img
                    src={`https://img.youtube.com/vi/${video.videoId}/mqdefault.jpg`}
                    alt="preview"
                    style={{ width: "100%", borderRadius: "8px" }}
                  />
                </Box>
              </CardContent>

              <CardActions>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => approveVideo(video._id)}
                >
                  Approve
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => rejectVideo(video._id)}
                >
                  Reject
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
